module.exports = __webpack_public_path__ + "static/media/winterweave-logo.9c8f2034.jpg";